module.exports = __webpack_public_path__ + "static/InfectedPersonsPrefecture_34.dot-c12116e3e0c64014be958846e430be58.svg";